import valigia_del_parto from "../assets/valigia_del_parto.jpg";
import gravidanza_lettura from "../assets/gravidanza_lettura.jpg"
import depressione_post_partum from "../assets/depressione_post_partum.jpg"
import valigia_del_parto_file from "../assets/valigia_del_parto_file.pdf"
import Maternita_tra_aspettative_e_realta from "../assets/Maternita_tra_aspettative_e_realta.pdf"

export const elencoletture = [
    {
        index: 0,
        download: valigia_del_parto_file,
        img: valigia_del_parto,
        title: "La Valigia Del Parto",
        text: "I nove mesi trascorsi in gravidanza sono un periodo di attesa, di limbo, in cui vediamo il nostro corpo mutare e plasmare una nuova creatura. All'incredulità e alla meraviglia nel vederci in questa veste creatrice associamo una serie di fantasie su come sarà colei/colui che portiamo in grembo, come sarà la nostra nuova vita, come sarà il nostro primo incontro. E per addolcire (e ingannare) l'attesa iniziamo a pensare a tutto ciò che potrebbe servirci per questo incontro e per i mesi a venire. Non c'è un momento adatto per iniziare a pensare o acquistare i più disparati oggetti della prima infanzia, i primi completini o i primi giochi. Ogni coppia è a sé, ogni coppia che si prepara a diventare triade sceglie il momento in cui mettere da parte la scaramanzia e iniziare a pensare concretamente all'arrivo di un figlio. Non c'è un momento adatto nemmeno per preparare la valigia del parto, il momento adatto è il momento in cui ci si sente pronte, in cui razionalmente ci diciamo che siamo pronte ad affrontare quello che verrà, siamo pronte a pensare che un giorno ci separeremo da lei/lui e dal nostro pancione. Da qui un mio Consiglio personale: ascoltatevi e decidete, senza influenze esterne, quale è il VOSTRO momento adatto per dedicarvi a questa azione così semplice ma che racchiude simbolicamente un grande passaggio della nostra vita. Ho pensato potesse esservi utile un elenco dal quale prendere spunto. Ogni ospedale prevede una personale lista di oggetti necessari durante la degenza di mamma e bambina/o. È importante capire di cosa necessitiamo realmente in quei giorni, cosa potrebbe aiutarci a ricreare un ambiente confortevole e simile a casa, di cosa necessita la/il vostra/o bimba/o appena venuta/o al mondo e cosa invece potrebbe venirci fornito dall'ospedale. All'interno del pdf trovate anche un link in cui potrete trovare una lista della maggior parte degli ospedali e di ciò che richiedono.",
    },
    {
        index: 1,
        img: gravidanza_lettura,
        download : Maternita_tra_aspettative_e_realta,
        title: "Gravidanza, tra aspettative e realtà",
        text: "Le aspettative presenti in ciascuna di noi rispetto alla maternità non sempre rispecchiano la realtà di fronte alla quale poi ci ritroviamo. E questo può portare a smarrimento, paura, talvolta senso di colpa, che non ha ragione di esistere. Investiamo corpo e mente nella creazione di un altro essere umano e viene naturale immaginarlo, percorrere certi momenti nella mente ingannando l'attesa. Non solo, quanto i luoghi comuni, le esperienze altrui e i pregiudizi inficiano sulle nostre aspettative? Quanto veramente godiamo di questi nove mesi, del parto e dei successivi mesi se siamo invase dalle esperienze degli altri? Ho pensato potesse farti piacere un pdf con una riflessione su questo argomento.",
    },
    {
        index: 2,
        img: depressione_post_partum,
        download:"",
        link : "https://docs.google.com/forms/d/e/1FAIpQLSdoHQiqKpWwM-_RydtWnBIyk3znKdUYY4EzwPqMDGBNYV4lrQ/viewform?usp=sf_link",
        title: "Screening Depressione Post Partum",
        text: `<div>
        <p>
            L’arrivo di un figlio coinvolge il corpo e la mente di una madre per diversi mesi a partire dalla
            gravidanza.
        </p>
        <p>
            La sopravvivenza stessa della gravidanza è dovuta in parte ad un equilibrio ormonale specifico della
            gravidanza che viene a cessare al momento del parto, quando non è più necessario.
        </p>

        <p>
            Questo crollo ormonale produce nel corpo uno squilibrio che insieme ai cambiamenti dati dall’arrivo di
            un figlio e alle preoccupazioni dovute allo stesso provoca in una buona percentuale di donne il
            cosiddetto Baby Blues, ovvero una condizione totalmente FISIOLOGICA che inizia a partire dalle
            primissime settimane dopo il partoe termina intorno alla sesta settimana dopo il parto. I sintomi
            riconducibili al baby blues sono:
        </p>

        <ul>
            <li>Umore instabile</li>
            <li>Ansia e nervosismo</li>
            <li>Tristezza non giustificata</li>
            <li>Irritabilità</li>
            <li>Pianto improvviso e immotivato</li>
            <li>Difficoltà di concentrazione</li>
            <li>Disturbi del sonno</li>
        </ul>
    </div>

    <div>
        <p>
            Queste sensazioni, nonostante appartengano completamente alla fisiologia, non vanno trascurate o
            relegate ad una fase a cui semplicemente “sopravvivere”, vanno invece riconosciute ed affrontate.
        </p>
        <h3 class="py-3">In quale modo?</h3>

        <p>Confrontati con qualcuno che senti vicino a te</p>
        <p>Chiedi aiuto per poterti rilassare e concedere del tempo per te</p>
        <p>Accogli le sensazioni che ti arrivano, sia quelle positive che quelle negative</p>
        <p>
            Non sei “sbagliata”, sei una fase delicata, stai dando il meglio per il tuo bimbo/a ed è assolutamente
            naturale e comprensibile sentirsi sopraffatte e stanche
        </p>
        Nel momento in cui queste sensazioni sopra descritte eccedano la fisiologia o si prolunghino in un periodo
        di tempo maggiore delle 4/6 settimane va presa in considerazione la possibilità che si stia sviluppando un
        vero e proprio disturbo chiamato Depressione Post Partum che richiede un supporto professionale e competente
        dalle figure preposte a questo.
    </div>
    <div>
        <h3 class="py-3">Cosa fare?</h3>
        <p>
            NEL CASO TU SIA UN FAMILIARE O UN AMICO di una donna che presenta i sintomi sopra citati ricordati che
            davanti a te hai una persona che sta attraversando un periodo di difficoltà che può tranquillamente`
    },
];
